import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { icon, MediaBreakPointUp, MediaBreakPointDown } from '@lean-body/components/styles';
const { useState } = React;
export const SearchTreeView = (props) => {
    const [isOpen, setIsOpen] = useState(true);
    const openClose = () => {
        setIsOpen(!isOpen);
    };
    const containerStyle = [css(styles.containter), props.isFirst ? css(styles.firstContainer) : ''].join(' ');
    const arrowStyle = [
        css(styles.arrow),
        css(icon.anticon),
        isOpen ? css(icon.anticonArrowUp) : css(icon.anticonArrowDown),
    ].join(' ');
    const header = () => {
        return (React.createElement("div", { className: css(styles.headerContainer), onClick: openClose },
            React.createElement("div", { className: css(styles.headerTitle) }, props.title),
            React.createElement("i", { className: arrowStyle })));
    };
    return (React.createElement("div", { className: containerStyle },
        React.createElement("div", { className: css(styles.contents) },
            header(),
            isOpen ? props.children : '')));
};
const styles = StyleSheet.create({
    containter: {
        borderBottom: '1px solid #DDDDDD',
        [MediaBreakPointDown.SM]: {
            // 親要素のmarginを無視するため
            marginLeft: 'calc(((100vw - 100%) / 2) * -1)',
            marginRight: 'calc(((100vw - 100%) / 2) * -1)',
        },
    },
    contents: {
        margin: '0 12px 0 24px',
    },
    firstContainer: {
        borderTop: '1px solid #DDDDDD',
    },
    headerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        [MediaBreakPointUp.XL]: {
            marginRight: '12px',
        },
    },
    headerTitle: {
        fontWeight: 500,
        fontSize: '1.2rem',
        color: '#65CED9',
        margin: '1rem 0',
    },
    arrow: {
        fontSize: '1.2rem',
        color: '#333333',
    },
});
